export enum VehicleCondition {
  New = 1,
  Used = 2,
}

export const VEHICLE_CONDITION_LABELS: Readonly<Record<VehicleCondition, string>> = {
  [VehicleCondition.New]: 'VEHICLE.VEHICLE_CONDITION.NEW',
  [VehicleCondition.Used]: 'VEHICLE.VEHICLE_CONDITION.USED',
};
